<template>
  <p v-if="type === 'block'" class="tb-text-ellipsis block"
    :class="[align, multiline, customClass]"
  >
    <slot></slot>
  </p>
  <span v-else class="tb-text-ellipsis inline"
    :class="[align, multiline, customClass]"
  >
    <slot></slot>
  </span>
</template>

<script>

export default {
  name: 'text-ellipsis',
  props: {
    type: {
      default: 'block',
      type: String
    },
    line: {
      default: '',
      type: String
    },
    align: {
      default: '',
      type: String
    },
    customClass: {
      default: '',
      type: String
    }
  },
  computed: {
    multiline () {
      if (this.line === '2') return 'multiline_2'
      else if (this.line === '3') return 'multiline_3'
      else return false
    }
  }
}
</script>

<style scoped lang="scss">

.tb-text-ellipsis {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &.inline {
    display: inline-block;
  }

  // multiline
  &.multiline_2 {
    white-space: normal;
    word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-height: 1.2em;
    &.block {
      height: 2.4em;
    }
  }
  &.multiline_3 {
    white-space: normal;
    word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-height: 1.2em;
    &.block {
      height: 3.6em;
    }
  }

  // align
  &.left {
    text-align: left;
  }
  &.center {
    text-align: center;
  }
  &.right {
    text-align: right;
  }

}
</style>
